import React from 'react';
import moment, { tz } from 'moment-timezone';
import { Button, LabeledInput, CopyIcon } from "@commonsku/styles";
import {oauth} from '../../utils';

const GeneratePasswordResetLink = () => {
  const [error, setError] = React.useState<string>('');
  const [resetUrl, setResetUrl] = React.useState<string>('');
  const [expiryDate, setExpiryDate] = React.useState<string>('');

  return <form action="" onSubmit={async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    setResetUrl(''); // Clear previous reset URL
    setExpiryDate(''); // Clear previous expiry date

    try {
      const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
      const response = await oauth('POST', 'tech-support', {
        ...formData,
        actionName: 'generate_password_reset_link',
      });

      const data = response.json;
      setResetUrl(data.reset_url);

      // Use the actual expiry date from the database
      if (data.reset_code_expiry) {
        const expiry = moment(data.reset_code_expiry * 1000);
        setExpiryDate(tz(expiry, tz.guess()).format('YYYY-MM-DD HH:mm:ss z'));
      }
    } catch (err) {
      setError(err.json?.error || 'An error occurred');
    }
  }}>
    <LabeledInput
      label="Login Name"
      placeholder="Login Name"
      name="login_name"
      type="text"
      required
    />
    <Button type="submit">Generate Password Reset Link</Button>
    {error && <div style={{color: 'red', marginTop: '10px'}}>{error}</div>}

    {resetUrl && (
      <div style={{marginTop: '20px'}}>
        <div style={{marginBottom: '10px'}}>
          <strong>Reset Link:</strong>
          <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <div style={{flex: 1, padding: '8px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '3px', fontFamily: 'monospace', fontSize: '12px', wordBreak: 'break-all'}}>
              {resetUrl}
            </div>
            <CopyIcon
              onClick={() => navigator.clipboard.writeText(resetUrl)}
              style={{cursor: 'pointer'}}
            />
          </div>
        </div>
        <div>
          <strong>Link Expires:</strong> {expiryDate}
        </div>
      </div>
    )}
  </form>;
};

GeneratePasswordResetLink.label = `Generate Password Reset Link`;

export default GeneratePasswordResetLink;
